module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modals"
    }
  }, [_c('EditBoardPane'), _vm._v(" "), _c('EditBoardLadder'), _vm._v(" "), _c('EditBoardFixing'), _vm._v(" "), _c('EditBoardHook'), _vm._v(" "), _c('EditBoardShelf'), _vm._v(" "), _c('EditBoardModule'), _vm._v(" "), _c('EditBoardCaddy'), _vm._v(" "), _c('EditBoardSeparator'), _vm._v(" "), _c('EditGrid'), _vm._v(" "), _c('ExtendsPane'), _vm._v(" "), _c('EditPaper'), _vm._v(" "), _c('GenerateHooks'), _vm._v(" "), _c('MoveFixings', {
    key: "moveFixing"
  }), _vm._v(" "), (_vm.datas) ? _c('GenerateLadders', {
    attrs: {
      "brandId": _vm.datas.brand.id,
      "zoneId": _vm.datas.zone && _vm.datas.zone.id,
      "zones": _vm.datas.zones && _vm.datas.zones.map(function (z) { return z.id; }),
      "campaignId": _vm.datas.campaign && _vm.datas.campaign.id
    },
    on: {
      "close": function($event) {
        _vm.visible = false;
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.datas) ? _c('GenerateFixings', {
    attrs: {
      "brandId": _vm.datas.brand.id,
      "zoneId": _vm.datas.zone && _vm.datas.zone.id,
      "zones": _vm.datas.zones && _vm.datas.zones.map(function (z) { return z.id; }),
      "campaignId": _vm.datas.campaign && _vm.datas.campaign.id
    },
    on: {
      "close": function($event) {
        _vm.visible = false;
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.datas && _vm.datas.id) ? _c('DisplayInfo', {
    key: "displayInfo",
    attrs: {
      "datas": _vm.datas
    }
  }) : _vm._e(), _vm._v(" "), _c('RenameFavorite', {
    key: "renameFavorite",
    on: {
      "rename": function (builder) { return _vm.$emit('rename-favorite', builder); }
    }
  }), _vm._v(" "), (_vm.datas) ? _c('EditComment', {
    key: "editComment",
    attrs: {
      "planoId": _vm.datas.id
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40d508d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/index.vue
// module id = 3143
// module chunks = 0